/* Quiz popup, tap-the-backdrop-to-dismiss (added 2026-06-02)
   Loaded site-wide (deferred) by snippets/quiz-popup.liquid. RevenueHunt has no
   native backdrop close, but its close button is a parent-side <span> inside
   .rh-modal, so we forward a backdrop click to it. That triggers RH's OWN close
   (releases the body scroll-lock, allows reopen) instead of removing the overlay
   ourselves (which desyncs RH and breaks reopening for the rest of the session).
   Delegated on document because RH injects .rh-modal dynamically; bound once. */
(function () {
  if (window.__wsbRhBackdropClose) return;
  window.__wsbRhBackdropClose = true;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('rh-modal')) {
      var x = t.querySelector('.rh-widget > span') || t.querySelector('span');
      if (x) { x.click(); }
    }
  }, false);
})();
